<template>
  <div class="beginning">
    <app-container v-if="test">
      <h1 class="beginning__title">{{ test.base.name }}</h1>
      <div class="page-grid">
        <div class="page-grid__content">
          <div
            class="info"
          >
            <p class="info__title">
              Что тебе предстоит?
            </p>
            <p v-html="test.base.description" />
          </div>
          <app-button
            class="beginning__button"
            @click.native="nextPage()"
          >
            {{ test.base.button }}
          </app-button>
        </div>
        <img
          class="page-grid__image"
          src="@/assets/images/testing-bg.svg"
        >
      </div>
    </app-container>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import AppContainer from '../components/Base/AppContainer';
import AppButton from '../components/Base/AppButton';

export default {
  name: 'Beginning',
  components: {
    AppContainer,
    AppButton,
  },
  computed: {
    ...mapState('tests', ['test']),
  },
  mounted() {
    if (localStorage.getItem('user') && !this.test) {
      this.$store.dispatch('tests/load', this.$route.params.id);
    }
  },
  methods: {
    nextPage() {
      const testId = this.$route.params.id;
      return this.$router.push(`/${testId}/testing`);
    },
  },
};
</script>

<style lang="scss" scoped>
  .beginning {
    padding: 30px 0 40px 0;
    &__button {
      margin-top: 50px;
    }
  }
  .info {
    padding: 16px;
    width: 540px;
    background: #FFFFFF;
    border: 1px solid #DBDBDB;
    box-sizing: border-box;
    box-shadow: 0 4px 14px rgba(70, 97, 138, 0.2);
    border-radius: 8px;
    &__title {
      font-family: 'Open sans', 'sans-serif';
      font-weight: 600;
      color: #2F3C61;
      font-size: 23px;
      margin: 0 0 20px;
    }
    &__list {
      padding: 0;
      margin: 0;
      list-style: none;
    }
    &__item {
      margin-bottom: 20px;
      &:last-child {
        margin: 0;
      }
    }
  }

  @media screen and (max-width: $window-md) {
    .info {
      width: 100%;
    }
  }

  @media screen and (max-width: $window-sm) {
    .beginning{
      &__title {
        font-size: 28px;
      }
      &__button {
        width: 100%;
      }
    }
  }
</style>
